import {FC} from "react";

interface iSliderNavigation {
    switchSlide: (value?: number) => void,
    currentIndex: number
}

export const SliderNavigation: FC<iSliderNavigation> = ({ switchSlide, currentIndex }) => (
    <div className="SliderNavigation">
        {[0,1,2].map((index) => (
            <span 
                key={`SliderNavigation-indicator-${index}`}
                className={`SliderNavigation-indicator${currentIndex === index ? " active" : ""}`} 
                onClick={() => currentIndex === index ? null : switchSlide(index)} 
            />
        ))}
    </div>
)